import type { IUser } from '@manager/api/types/auth-types';
import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const routesGlobalSettings: RouteMetaConfig[] = [
  {
    path: '/global-settings',
    name: routeNames.globalSettings,
    component: () => import('./GlobalSettingsDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'tenant_storefronts.view',
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.globalSettingsEditDesign,
          path: 'edit/design',
          meta: {
            requiresAuth: true,
            permission: 'tenant_storefronts.update',
          },
          component: () => import('./GlobalSettingsDesignEditView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.globalSettingsEditGeneral,
          path: 'edit/general',
          meta: {
            requiresAuth: true,
            permission: 'tenant_storefronts.update',
            additionalCheck: (user: IUser) =>
              !user.tenant_features.allow_location_domain,
          },
          component: () => import('./GlobalSettingsGeneralEditView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.globalSettingsEditMarketing,
          path: 'edit/marketing',
          meta: {
            requiresAuth: true,
            permission: 'tenant_storefronts.update',
            additionalCheck: (user: IUser) =>
              !user.tenant_features.allow_location_domain,
          },
          component: () => import('./GlobalSettingsMarketingEditView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.globalSettingsEditIntegrations,
          path: 'edit/integrations',
          meta: {
            requiresAuth: true,
            permission: 'tenant_storefronts.update',
          },
          component: () => import('./GlobalSettingsIntegrationsEditView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          name: routeNames.globalSettingsEditConsents,
          path: 'edit/consents',
          meta: {
            requiresAuth: true,
            permission: 'tenant_storefronts.update',
          },
          component: () => import('./GlobalSettingsConsentsEditView.vue'),
        },
        { fullscreen: false }
      ),
    ],
  },
];
